import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Message from "semantic-ui-react/dist/es/collections/Message/Message.js";
import { withResponsive } from "../../../utils/with-responsive";
import { Grid } from "../../layout/Grid";
import { GridRow } from "../../layout/GridRow";
import { GridColumn } from "../../layout/GridColumn";
import { Heading } from "../../typography/Heading";
import { ShowOn } from "../../layout/ShowOn";
import { TextInput } from "../../inputs/TextInput";
import { Button } from "../../elements/Button";
import { Divider } from "../../elements/Divider";
import { HorizontalGutters } from "../../layout/HorizontalGutters";
import { ACCEPT_PRIVACY_POLICY, FORM_PROTECTION, SUBSCRIBE, SUBSCRIBE_TO_OUR_NEWSLETTER, YOUR_EMAIL } from "../../../utils/default-strings";
import { getPrivacyCheckboxMarkup } from "./utils/getPrivacyCheckboxMarkup";
import { getTextAlign } from "./utils/getTextAlign";

var Component = function Component(_ref) {
  var botProtectionMessage = _ref.botProtectionMessage,
      buttonText = _ref.buttonText,
      emailInputError = _ref.emailInputError,
      emailInputLabel = _ref.emailInputLabel,
      emailInputValue = _ref.emailInputValue,
      errorMessage = _ref.errorMessage,
      headingText = _ref.headingText,
      isBotProtected = _ref.isBotProtected,
      isPrivacyConsentInputChecked = _ref.isPrivacyConsentInputChecked,
      isPrivacyConsentRequired = _ref.isPrivacyConsentRequired,
      isUserOnMobile = _ref.isUserOnMobile,
      onChangeEmailInput = _ref.onChangeEmailInput,
      onClickButton = _ref.onClickButton,
      onClickPrivacyConsentInput = _ref.onClickPrivacyConsentInput,
      privacyConsentInputError = _ref.privacyConsentInputError,
      privacyConsentLabelLinkText = _ref.privacyConsentLabelLinkText,
      privacyConsentLabelLinkUrl = _ref.privacyConsentLabelLinkUrl,
      privacyConsentLabelText = _ref.privacyConsentLabelText,
      successMessage = _ref.successMessage;
  return React.createElement(Fragment, null, (!!errorMessage || !!successMessage) && React.createElement(Grid, {
    areColumnsCentered: true
  }, React.createElement(GridColumn, {
    textAlign: getTextAlign(isUserOnMobile),
    width: 11
  }, !!errorMessage && React.createElement(Message, {
    content: errorMessage,
    error: true
  }), !!successMessage && React.createElement(Message, {
    content: successMessage,
    success: true
  }))), React.createElement(HorizontalGutters, null, React.createElement(Divider, null), React.createElement(Grid, null, React.createElement(GridRow, {
    verticalAlign: "middle"
  }, React.createElement(Fragment, null, React.createElement(GridColumn, {
    computer: 5,
    mobile: 12,
    tablet: 12,
    textAlign: "center"
  }, React.createElement(Heading, {
    hasMargin: false,
    size: "small"
  }, headingText), React.createElement(ShowOn, {
    mobile: true,
    parent: Divider,
    parentProps: {
      size: 'small'
    },
    tablet: true
  })), React.createElement(GridColumn, {
    computer: 4,
    mobile: 12,
    tablet: 7
  }, React.createElement(TextInput, {
    error: emailInputError,
    isFluid: true,
    label: emailInputLabel,
    onChange: onChangeEmailInput,
    value: emailInputValue
  }), React.createElement(ShowOn, {
    mobile: true,
    parent: Divider,
    parentProps: {
      size: 'small'
    }
  })), React.createElement(GridColumn, {
    computer: 3,
    mobile: 12,
    tablet: 5
  }, isUserOnMobile && (isPrivacyConsentRequired || isBotProtected) && React.createElement(Fragment, null, isBotProtected && React.createElement(Fragment, null, botProtectionMessage, React.createElement(Divider, null)), React.createElement(Divider, null), isPrivacyConsentRequired && getPrivacyCheckboxMarkup(privacyConsentInputError, isPrivacyConsentInputChecked, privacyConsentLabelText, privacyConsentLabelLinkUrl, privacyConsentLabelLinkText, onClickPrivacyConsentInput), React.createElement(Divider, null)), React.createElement(Button, {
    isFluid: true,
    isRounded: true,
    onClick: onClickButton
  }, buttonText)))), !isUserOnMobile && (isPrivacyConsentRequired || isBotProtected) && React.createElement(GridRow, null, React.createElement(GridColumn, {
    computer: 5
  }), React.createElement(GridColumn, {
    computer: 7,
    mobile: 12,
    tablet: 12
  }, isBotProtected && React.createElement(Fragment, null, botProtectionMessage, React.createElement(Divider, null)), isPrivacyConsentRequired && getPrivacyCheckboxMarkup(privacyConsentInputError, isPrivacyConsentInputChecked, privacyConsentLabelText, privacyConsentLabelLinkUrl, privacyConsentLabelLinkText, onClickPrivacyConsentInput)))), React.createElement(Divider, null)));
};

export var ComponentWithResponsive = withResponsive(Component);
Component.displayName = 'EmailCapture';
Component.defaultProps = {
  botProtectionMessage: FORM_PROTECTION,
  buttonText: SUBSCRIBE,
  emailInputError: false,
  emailInputLabel: YOUR_EMAIL,
  emailInputValue: undefined,
  errorMessage: null,
  headingText: SUBSCRIBE_TO_OUR_NEWSLETTER,
  isBotProtected: false,
  isPrivacyConsentInputChecked: false,
  isPrivacyConsentRequired: false,
  onChangeEmailInput: Function.prototype,
  onClickPrivacyConsentInput: Function.prototype,
  onClickButton: Function.prototype,
  privacyConsentInputError: undefined,
  privacyConsentLabelLinkText: undefined,
  privacyConsentLabelLinkUrl: undefined,
  privacyConsentLabelText: ACCEPT_PRIVACY_POLICY,
  successMessage: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  botProtectionMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  buttonText: PropTypes.string,
  emailInputError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  emailInputLabel: PropTypes.string,
  emailInputValue: PropTypes.string,
  errorMessage: PropTypes.string,
  headingText: PropTypes.string,
  isBotProtected: PropTypes.bool,
  isPrivacyConsentInputChecked: PropTypes.bool,
  isPrivacyConsentRequired: PropTypes.bool,
  isUserOnMobile: PropTypes.bool.isRequired,
  onChangeEmailInput: PropTypes.func,
  onClickButton: PropTypes.func,
  onClickPrivacyConsentInput: PropTypes.func,
  privacyConsentInputError: PropTypes.string,
  privacyConsentLabelLinkText: PropTypes.string,
  privacyConsentLabelLinkUrl: PropTypes.string,
  privacyConsentLabelText: PropTypes.node,
  successMessage: PropTypes.string
} : {};